export const Types = {
  REQUEST: '@recaptcha/REQUEST',
  FAILURE: '@recaptcha/FAILURE',
  SITE_KEY: '@recaptcha/SITE_KEY',
  SUCCESS_KEY: '@recaptcha/SUCCESS_KEY',
};

interface IRecaptchaRequestReturn {
  type: string;
}

interface IRecaptchaFailureReturn {
  type: string;
  error: Object;
}

interface ISetKeyKeyReturn {
  type: string;
  payload: string;
}

export function recaptchaRequest(): IRecaptchaRequestReturn {
  return {
    type: Types.REQUEST,
  };
}

export function recaptchaFailure(error: Object): IRecaptchaFailureReturn {
  return {
    type: Types.FAILURE,
    error,
  };
}

export function setSiteKey(key: string): ISetKeyKeyReturn {
  return {
    type: Types.SITE_KEY,
    payload: key,
  };
}

export function setSuccessKey(key: string): ISetKeyKeyReturn {
  return {
    type: Types.SUCCESS_KEY,
    payload: key,
  };
}
